import * as actionTypes from "../actionTypes";
import * as storageConstants from "../../shared/utils/constants/storage";
import SettingsService from "../../api/settingsService";

export const reportSetSelectedTab = (value) => {
    sessionStorage.setItem(storageConstants.REPORT_TAB, value);
    return {
        type: actionTypes.REPORT_SET_SELECTED_TAB,
        selectedTab: value
    }
}

export const setReportLinks = () => {
    return dispatch => {
        SettingsService.fetchReportLinks().then(res => {
            dispatch({
                type: actionTypes.SET_REPORT_LINKS,
                links: res.data
            });
        }).catch(e => {
            console.log(e);
        })
    }
}

export const setSingloaMsisdn = (msisdn) => {
    return {
        type: actionTypes.SET_SINGLOA_MSISDN,
        msisdn: msisdn
    }
}

export const setSelectedBulk = (groupKey) => {
    return {
        type: actionTypes.SET_BULK_GROUP_KEY_REPORT,
        selectedBulk: groupKey
    }
}
